export const JobSegments = {
  WORK_ITEMS: 'workItems',
  DETAILS: 'details',
  FULLY_RETURNED: 'fullyReturned',
  ADDITIONAL_INFORMATION: 'additionalInformation',
} as const;

export type JobSegments = (typeof JobSegments)[keyof typeof JobSegments];
